import React from 'react'
import {Link} from 'react-router-dom'

class BottomNav extends React.Component {
  render() {
    return(
      <footer className="page-footer orange darken-2 show-on-medium-and-down center">
          <ul className="footer-list">
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Me</Link></li>
            <li><Link to="/portfolio">Portfolio</Link></li>
            <li><Link to="/contact">Contact</Link></li>
          </ul>
      </footer>
    )
  }
}

export default BottomNav;